import moment from 'moment';

export type Timeframe = 'this-month' | '30-days' | 'last-month' | '90-days' | 'this-year' | 'last-year' | 'last-365';


export type Range = {
    from: Date
    to: Date
}


export const getRange = (frame: Timeframe): Range => {
    const now = moment()

    if (frame === 'this-month') {
        return {
            to: now.clone().endOf('day').toDate(),
            from: now.clone().startOf('month').toDate()
        }
    } else if (frame === '30-days') {
        return {
            to: now.clone().endOf('day').toDate(),
            from: now.clone().subtract(30, 'days').toDate()
        }
    } else if (frame === 'last-month') {
        return {
            to: now.clone().subtract(1, 'month').endOf('month').toDate(),
            from: now.clone().subtract(1, 'month').startOf('month').toDate()
        }
    } else if (frame === '90-days') {
        return {
            to: now.clone().endOf('day').toDate(),
            from: now.clone().subtract(90, 'days').toDate()
        }
    } else if (frame === 'this-year') {
        return {
            to: now.clone().endOf('day').toDate(),
            from: now.clone().startOf('year').startOf('day').toDate()
        }
    } else if (frame === 'last-year') {
        return {
            to: now.clone().subtract(1, 'year').endOf('year').toDate(),
            from: now.clone().subtract(1, 'year').startOf('year').startOf('day').toDate()
        }
    } else if (frame === 'last-365') {
        return {
            to: now.clone().endOf('day').toDate(),
            from: now.clone().subtract(365, 'days').startOf('day').toDate()
        }
    }


    return {
        to: now.clone().toDate(),
        from: now.clone().subtract(90, 'days').toDate()
    }
}
